export default function hexConverter(hex) {
  let opacity = '0.1';
  let red = parseInt(hex.substring(1, 3), 16);
  let green = parseInt(hex.substring(3, 5), 16);
  let blue = parseInt(hex.substring(5, 7), 16);
  return `rgba(${red}, ${green}, ${blue}, ${opacity})`;
}
